import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import * as Utils from '../../commons/utils/Utils.js';
import { Modal, Backdrop, Grow } from '@material-ui/core';
import Switch from 'react-switch';

const RepuestosGridExport = ({ modalExport, setModalExport, columnsEnabled, filterQuery }) => {
  const [dataToExport, setDataToExport] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (modalExport) {
      setDataToExport({ ...columnsEnabled });
    } else {
      setLoading(false);
    }
  }, [modalExport]);

  const handleDataExportChange = (col) => {
    setDataToExport({ ...dataToExport, [col]: !dataToExport[col] });
  };

  const handleExport = () => {
    setLoading(true);
    Utils.dataBlob('/panol2/repuestos/exportar-excel', 'POST', {
      colsAExportar: dataToExport,
      filterQuery: filterQuery,
    })
      .then((res) => {
        const filename = res && res.filename ? res.filename.replace(/"/g, '') : 'fleet-repuestos-servicios.xlsx';
        const fileUrl = URL.createObjectURL(res.data);
        const a = document.createElement('a');
        a.href = fileUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(() => URL.revokeObjectURL(fileUrl), 0);
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
        setModalExport(false);
      });
  };

  return (
    <Modal
      open={modalExport}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 1000 }}
    >
      <Grow in={modalExport}>
        <div tabIndex="-1" id="repuestos_export_modal" role="dialog">
          <div className="modal-xl modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header bg-fleet">
                <h4 className="modal-title text-white">
                  <i className="ft-download align-middle icon-modal-title" />
                  <FormattedMessage id="repuestosGridExport.tituloItems" defaultMessage=" Exportar Ítems" />
                </h4>
                <button type="button" className="close" onClick={() => setModalExport(false)}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body modal-grey modal-mh ovf-x-hidden">
                <div className="row">
                  <div className="col-md-12">
                    <form className="form form-horizontal">
                      <div className="form-body">
                        <div className="card pull-up">
                          <div className="card-content">
                            <div className="card-body">
                              <h4 className="form-section">
                                <i className="la la-columns" />
                                <FormattedMessage id="repuestosGridExport.columnas_a_exportar" defaultMessage=" Columnas a exportar" />
                              </h4>
                              <div className="row">
                                {dataToExport && columnsEnabled.external_code && (
                                  <div className="col-md-3" style={{ display: 'flex', alignItems: 'center', padding: '4px 0px' }}>
                                    <label className="col-md-6 label-control col-form-label" htmlFor="external_code">
                                      <FormattedMessage id="repuestosGridExport.col.external_code" defaultMessage="Código Externo" />:
                                    </label>
                                    <Switch onChange={() => handleDataExportChange('external_code')} checked={!!dataToExport.external_code} offColor="#FF4961" onColor="#28D094" disabled={loading} className="col-md-6 align-middle" />
                                  </div>
                                )}
                                {dataToExport && columnsEnabled.descripcion && (
                                  <div className="col-md-3" style={{ display: 'flex', alignItems: 'center', padding: '4px 0px' }}>
                                    <label className="col-md-6 label-control col-form-label" htmlFor="descripcion">
                                      <FormattedMessage id="repuestosGridExport.col.descripcion" defaultMessage="Descripción" />:
                                    </label>
                                    <Switch onChange={() => handleDataExportChange('descripcion')} checked={!!dataToExport.descripcion} offColor="#FF4961" onColor="#28D094" disabled={loading} className="col-md-6 align-middle" />
                                  </div>
                                )}
                                {dataToExport && columnsEnabled.categoria && (
                                  <div className="col-md-3" style={{ display: 'flex', alignItems: 'center', padding: '4px 0px' }}>
                                    <label className="col-md-6 label-control col-form-label" htmlFor="categoria">
                                      <FormattedMessage id="repuestosGridExport.col.categoria" defaultMessage="Categoría" />:
                                    </label>
                                    <Switch onChange={() => handleDataExportChange('categoria')} checked={!!dataToExport.categoria} offColor="#FF4961" onColor="#28D094" disabled={loading} className="col-md-6 align-middle" />
                                  </div>
                                )}
                                {dataToExport && columnsEnabled.subcategoria && (
                                  <div className="col-md-3" style={{ display: 'flex', alignItems: 'center', padding: '4px 0px' }}>
                                    <label className="col-md-6 label-control col-form-label" htmlFor="subcategoria">
                                      <FormattedMessage id="repuestosGridExport.col.subcategoria" defaultMessage="Sub-Categoría" />:
                                    </label>
                                    <Switch onChange={() => handleDataExportChange('subcategoria')} checked={!!dataToExport.subcategoria} offColor="#FF4961" onColor="#28D094" disabled={loading} className="col-md-6 align-middle" />
                                  </div>
                                )}
                                {dataToExport && columnsEnabled.unidad && (
                                  <div className="col-md-3" style={{ display: 'flex', alignItems: 'center', padding: '4px 0px' }}>
                                    <label className="col-md-6 label-control col-form-label" htmlFor="unidad">
                                      <FormattedMessage id="repuestosGridExport.col.unidad" defaultMessage="Unidad de Medida" />:
                                    </label>
                                    <Switch onChange={() => handleDataExportChange('unidad')} checked={!!dataToExport.unidad} offColor="#FF4961" onColor="#28D094" disabled={loading} className="col-md-6 align-middle" />
                                  </div>
                                )}
                                {dataToExport && columnsEnabled.tipo && (
                                  <div className="col-md-3" style={{ display: 'flex', alignItems: 'center', padding: '4px 0px' }}>
                                    <label className="col-md-6 label-control col-form-label" htmlFor="tipo">
                                      <FormattedMessage id="repuestosGridExport.col.tipo" defaultMessage="Tipo" />:
                                    </label>
                                    <Switch onChange={() => handleDataExportChange('tipo')} checked={!!dataToExport.tipo} offColor="#FF4961" onColor="#28D094" disabled={loading} className="col-md-6 align-middle" />
                                  </div>
                                )}
                                {dataToExport && columnsEnabled.numero_parte && (
                                  <div className="col-md-3" style={{ display: 'flex', alignItems: 'center', padding: '4px 0px' }}>
                                    <label className="col-md-6 label-control col-form-label" htmlFor="numero_parte">
                                      <FormattedMessage id="repuestosGridExport.col.numero_parte" defaultMessage="Nro de Parte" />:
                                    </label>
                                    <Switch onChange={() => handleDataExportChange('numero_parte')} checked={!!dataToExport.numero_parte} offColor="#FF4961" onColor="#28D094" disabled={loading} className="col-md-6 align-middle" />
                                  </div>
                                )}
                                {dataToExport && columnsEnabled.referencia && (
                                  <div className="col-md-3" style={{ display: 'flex', alignItems: 'center', padding: '4px 0px' }}>
                                    <label className="col-md-6 label-control col-form-label" htmlFor="referencia">
                                      <FormattedMessage id="repuestosGridExport.col.referencia" defaultMessage="Referencia" />:
                                    </label>
                                    <Switch onChange={() => handleDataExportChange('referencia')} checked={!!dataToExport.referencia} offColor="#FF4961" onColor="#28D094" disabled={loading} className="col-md-6 align-middle" />
                                  </div>
                                )}
                                {dataToExport && columnsEnabled.marca && (
                                  <div className="col-md-3" style={{ display: 'flex', alignItems: 'center', padding: '4px 0px' }}>
                                    <label className="col-md-6 label-control col-form-label" htmlFor="marca">
                                      <FormattedMessage id="repuestosGridExport.col.marca" defaultMessage="Marca" />:
                                    </label>
                                    <Switch onChange={() => handleDataExportChange('marca')} checked={!!dataToExport.marca} offColor="#FF4961" onColor="#28D094" disabled={loading} className="col-md-6 align-middle" />
                                  </div>
                                )}
                                {dataToExport && columnsEnabled.costo && (
                                  <div className="col-md-3" style={{ display: 'flex', alignItems: 'center', padding: '4px 0px' }}>
                                    <label className="col-md-6 label-control col-form-label" htmlFor="costo">
                                      <FormattedMessage id="repuestosGridExport.col.costo" defaultMessage="Costo" />:
                                    </label>
                                    <Switch onChange={() => handleDataExportChange('costo')} checked={!!dataToExport.costo} offColor="#FF4961" onColor="#28D094" disabled={loading} className="col-md-6 align-middle" />
                                  </div>
                                )}
                                {dataToExport && columnsEnabled.costo_fijo && (
                                  <div className="col-md-3" style={{ display: 'flex', alignItems: 'center', padding: '4px 0px' }}>
                                    <label className="col-md-6 label-control col-form-label" htmlFor="costo_fijo">
                                      <FormattedMessage id="repuestosGridExport.col.costo_fijo" defaultMessage="Costo Fijo" />:
                                    </label>
                                    <Switch onChange={() => handleDataExportChange('costo_fijo')} checked={!!dataToExport.costo_fijo} offColor="#FF4961" onColor="#28D094" disabled={loading} className="col-md-6 align-middle" />
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12 alert alert-info small" role="alert">
                          <FormattedMessage id="repuestosGridExport.accion_puede_demorar" defaultMessage="Esta acción puede demorar unos minutos." />
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="modal-footer modal-grey">
                <button
                  type="button"
                  className="btn btn-default btn-fleet"
                  onClick={handleExport}
                  disabled={loading}
                >
                  <i className={loading ? 'la la-spinner spinner' : 'fa fa-download'} />
                  <FormattedMessage id="repuestosGridExport.exportar" defaultMessage=" Exportar a Excel" />
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => setModalExport(false)}
                  disabled={loading}
                >
                  <i className="fa fa-times-circle" />
                  <FormattedMessage id="repuestosGridExport.cancelar" defaultMessage=" Cancelar" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </Grow>
    </Modal>
  );
};

export default RepuestosGridExport;
